export function filterProperReleases(versions) {
    if (!versions) {
        return [];
    }
    return versions
        ? (versions || []).filter((v) => v.version?.match(/^[0-9.]+$/))
        : [];
}
